function addCommissionDisclosure(planBenefitsJSON, carrierName: string) {
  const planBenefits = [...planBenefitsJSON.plan]

  const freeLookPeriodIndex = planBenefits.findIndex(planBenefit =>
    planBenefit.headline.includes('Free Look Period')
  )

  if (freeLookPeriodIndex < 0) {
    return planBenefitsJSON
  }

  const freeLookPeriod = planBenefits[freeLookPeriodIndex]

  freeLookPeriod.headline = 'Free Look and Agent Compensation Disclosure'

  const disclosureText = `COMPENSATION DISCLOSURE NOTICE: ${carrierName} appointed Writing Agents and Brokers receive direct issuing insurer compensation within a range of 15 -18% of monthly premiums while coverage is active, which varies within range based on state and writing agent performance in meeting new sales quotas. For residents of IA, IN, ND, NE, MS, TN the range is 11-14% and for residents of DE, OH, KS, VA the range is 10-13%. Please note that compensation differences do not change premiums being charged for coverage on an individual basis.`

  const commissionDisclosureBlock = {
    description: [
      {
        description: disclosureText,
        order: 10,
        id: null
      }
    ],
    displayOrder: 50,
    id: null
  }

  freeLookPeriod.body.push(commissionDisclosureBlock)

  return { ...planBenefitsJSON, plan: planBenefits }
}

export default addCommissionDisclosure
